var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-layout',[(_vm.showTabMenu)?_c('menu-view'):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"page-transition"}},[(_vm.keepAlive)?_c('keep-alive',[_c('router-view')],1):_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548a2277","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/BasicLayout.vue
// module id = cxAp
// module chunks = 22